export function clearStoredAuthSession() {
  localStorage.removeItem("karankiAuth");
  localStorage.removeItem("karankiProfilePhone");
  sessionStorage.removeItem("karankiOtpState");
}

export function getStoredAuthSession() {
  try {
    return JSON.parse(localStorage.getItem("karankiAuth") || "null");
  } catch {
    return null;
  }
}

export function getDefaultRouteForRole({ role, profileId }) {
  if (role === "admin") {
    return "/admin/dashboard";
  }

  if (role === "user") {
    return profileId ? "/dashboard" : "/create-profile";
  }

  return "/unauthorized";
}
